<template>
    <div class="tab-manager">
        <div class="tabs">
            <div class="logo"><img src="../Assets/logo-psflex.png" style="margin-right: 10px;">PsFlex</div>
            <div 
                v-if="activeTab != null"
                class="tab" 
                v-for="tab in tabs"
                :key="'tab.' + tab.id"
                v-bind:class="{ active: tab.id == activeTab.id}"
                v-on:click="setActiveTab(tab.id)">
                {{ tab.title }} <span class="close" v-on:click.stop="removeTab(tab.id)">x</span>
            </div>
            <div class="new" v-on:click="handleNewTabButton()">+</div>
        </div>
        <div class="content" v-for="tab in tabs" :key="tab.id" v-show="tab.id === activeTab.id">
            <CodeEditor 
                v-if="tab.type == 'CodeEditor'"
                :id="tab.id"
                :key="'CodeEditor.' + tab.id"
                />
            <ConfigEditor 
                v-if="tab.type == 'ConfigEditor'"
                :id="tab.id"
                :key="'ConfigEditor.' + tab.id"
                />
            <Help 
                v-if="tab.type == 'Help'"
                :id="tab.id"
                :key="'Help.' + tab.id"
                />
            <About 
                v-if="tab.type == 'About'"
                :id="tab.id"
                :key="'About.' + tab.id"
                />
        </div>
    </div>
</template>

<script>
    import { EventBus } from './../EventBus.js'
    import { Storage } from './../Storage.js'
    import { CodeExamples } from './../Helpers/CodeExamples.js'
    import CodeEditor from './CodeEditor/CodeEditor'
    import ConfigEditor from './ConfigEditor/ConfigEditor'
    import MazeGame from './MazeGame/MazeGame'
    import About from './Help/About'
    import Help from './Help/Help'

    export default {
        name: 'TabManager',
        components: {
            CodeEditor,
            ConfigEditor,
            MazeGame,
            About,
            Help
        },
        created () {
            this.tabs = Storage.getTabList()
            this.activeTab = Storage.getActiveTab()
            this.registerEventHandlers()
            if (this.tabs.length === 0) {
                this.handleNewTabButton()
            }
        },
        methods: {
            registerEventHandlers () {
                let fixedTabsConfig = [
                    { event: 'options.config', tabType: 'ConfigEditor', tabTitle: 'Configuración' },
                    { event: 'help.language', tabType: 'Help', tabTitle: 'Ayuda' },
                    { event: 'help.about', tabType: 'About', tabTitle: 'Acerca de' }
                ]

                // Eventos de pestañas Singleton
                for (let config of fixedTabsConfig) {
                    EventBus.$on(config.event, () => {
                        for (let i in this.tabs) {
                            if (this.tabs[i].type === config.tabType) {
                                this.activeTab = this.tabs[i].id
                                return
                            }
                        }
                        this.newTab(config.tabType, config.tabTitle, null)
                    })
                }

                // Eventos particulares
                EventBus.$on('editor.new', () => {
                    this.handleNewTabButton()
                })
                EventBus.$on('editor.open', (data) => {
                    this.newTab('CodeEditor', '', {
                        code: data.data,
                        predefinedEntries: ''
                    })
                })

                // Eventos de pestañas
                Storage.onTabListChange(tabs => {
                    this.tabs = tabs
                })
                Storage.onActiveTabChange(activeTab => {
                    this.activeTab = activeTab
                })
            },
            isCodeEditorActive () {
                return this.isValidTabActive() && this.activeTab.type === 'CodeEditor'
            },
            isValidTabActive () {
                return this.activeTab !== null
            },
            handleNewTabButton () {
                this.newTab('CodeEditor', '', {
                    code: CodeExamples.getInitialCode()
                })
            },
            newTab (type, title, data) {
                Storage.createTab(type, title || '', data)
            },
            removeTab (id) {
                if (this.activeTab.type === 'CodeEditor') {
                    if (!confirm('¿Seguro desea cerrar la pestaña actual?')) {
                        return
                    }
                }
                Storage.removeTab(id)
            },
            setActiveTab (id) {
                Storage.setActiveTab(id)
            }
        },
        data () {
            return {
                tabs: [],
                activeTab: null
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


    .tabs {
        position: absolute;
        top: 30px;
        left: 0px;
        right: 0px;
        height: 40px;
        background: #444;
        padding: 0px;
        margin: 0px;
    }

    .tabs .logo {
        line-height: 40px;
        padding-left: 20px;
        padding-right: 20px;
        text-shadow: 2px 2px 3px rgba(255,255,255,0.4);
        font-weight: 900;
        font-size: 25px;
        color: #EEE;
        display: inline-block;
    }

    .tabs .tab {
        background-color: #777;
        min-width: 100px;
        height: 26px;
        display: inline-block;
        line-height: 26px;
        padding-left: 10px;
        padding-right: 28px;
        font-size: 12px;
        margin-top: 1px;
        text-align: left;
        vertical-align: bottom;
        position: relative;
        cursor: pointer;
        color: #EEE;
        border-right: 1px solid #555;
    }

    .tabs .tab.active {
        color: #444;
        background: #F0F0F0;
        border-top: 3px solid #0066ff;
        border-top-right-radius: 2px;
        border-top-left-radius: 2px;
        border-right: 1px solid #777;

    }
    .tabs .tab:hover {
        color: #444;
        background-color: #CCC;
    }
    .tabs .tab.active:hover {
        color: #444;
        background: #F0F0F0;
        border-top: 3px solid #0066ff;
    }

    .tabs .tab .close {
        display: none;
        font-size: 14px;
        margin-left: 5px;
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 2px;
        color: #999;
        position: absolute;
        top: 50%;
        right: 8px;
        line-height: 14px;
        margin-top: -7px;
        cursor: pointer;
        vertical-align: middle;
        padding-bottom: 3px;
    }
    .tabs .tab.active .close {
        display: block;
    }


    .tabs .tab .close:hover {
        background-color: #DDD;
        color: #444;
    }

    .tabs .new {
        display: inline-block;
        color: #EEE;
        font-size: 22px;
        padding-right: 10px;
        padding-left: 10px;
        line-height: 26px;
        height: 26px;
        text-align: center;
        vertical-align: bottom;
        font-weight: 900;
        cursor: pointer;
        
    }

    .tabs .new:hover {
        background-color: #777;

    }
    .tabs .help {
        line-height: 30px;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 16px;
        color: #EEE;
        display: inline-block;
        position: absolute;
        right: 0px;
        top: 10px;
        
    }
    .tabs .help:hover {
        text-decoration: underline;
        color: #FFF;
        cursor: pointer;

    }


    .content {
        position: absolute;
        top: 70px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        overflow-y: auto;
    }

    .popup {
        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background-color: rgba(255,255,255, 0.8);
        z-index: 99999;
    }
    .popup .popup-content {
        position: relative;
        top: calc(50% - 250px);
        left: calc(50% - 110px);
        padding: 10px;
        width: 220px;
        background-color: #D8D8C0;
        border: 1px solid #999;
        border-radius: 6px;
        color: #333;
    }
    .popup .popup-content .link{
        text-align: center;
        padding: 8px;
    }

    .popup .popup-content .big-button {
        width: 200px;
        border: 1px solid #AAA;
        background-color: #F0F0F0;
        margin: 10px;
        padding-top: 20px;
        padding-bottom: 20px;
        line-height: 28px;
        font-size: 18px;
        text-align: center;
        border-radius: 3px;
    }
    .popup .popup-content .big-button:hover {
        background-color: #C0C8EA;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/Components/TabManager.vue